import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

import { formatUserName } from 'helper/formatUserName';
import { ArrowFilledDownIcon } from 'assets/icons';

import { DataGridErrorHelperText } from '../DataGridErrorHelperText';

const styles = {
  wrapper: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingInline: 2,
    height: 44,
    borderRadius: 8,
    border: '2px solid transparent',
    position: 'relative',
  },
  errorWrapper: ({ palette }) => ({
    borderColor: palette.error.main,
  }),
  text: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  placeholder: ({ palette }) => ({
    color: palette.colors.lightGrey,
  }),
  icon: ({ palette }) => ({
    color: palette.colors.darkPale,
    width: 12,
    height: 12,
    flexShrink: 0,
    marginLeft: 1,
  }),
};

export const DataGridOwnerCell = ({ value = null }) => {
  return (
    <Box sx={[styles.wrapper, !value && styles.errorWrapper]}>
      <Typography variant="body2" sx={[styles.text, !value && styles.placeholder]}>
        {formatUserName(value) || 'Assign Owner'}
      </Typography>

      <Box component={ArrowFilledDownIcon} sx={styles.icon} />

      {!value && <DataGridErrorHelperText />}
    </Box>
  );
};

DataGridOwnerCell.propTypes = {
  value: PropTypes.shape({
    id: PropTypes.number,
    full_name: PropTypes.string,
    email: PropTypes.string,
  }),
};
